
import React from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu'
import { HashRouter as Router, NavLink } from 'react-router-dom';
import { inject } from 'mobx-react';

import 'rc-dropdown/assets/index.css';

@inject('userStore')
class ProfileImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showMenu: false }

        this.toggleMenu = this.toggleMenu.bind(this);
    }

    toggleMenu () {
        this.setState((state, props) => {
            return {showMenu: !state.showMenu}
        })
    }
    onSelect({ key }) {
        console.log(`${key} selected`);
    }
      
    render () {
        const { member, userStore } = this.props;
        
        const menu = (
            <Router>
                <Menu onSelect={this.onSelect}>
                    <MenuItem key="0"><NavLink label="Account" to="/account">Account</NavLink></MenuItem>
                    <MenuItem key="1"><NavLink label="FAQs" to="/faqs">FAQs</NavLink></MenuItem>
                    <MenuItem key="2"><NavLink label="Log Out" to="#" onClick={ () => userStore.logout() }>Log Out</NavLink></MenuItem>
                </Menu>
            </Router>
          );
        return (
            <div>
                 <Dropdown
                     trigger={['click']}
                     overlay={menu}
                     animation="slide-up"
                 >
                    <button className="profile-container">{ `${member.firstName} ${member.lastName}` }</button>
                 </Dropdown>
            </div>
        )
    }

}

export default ProfileImage;